<template>
  <div>
  <el-dialog append-to-body width="640px" title="使用激活码" :visible.sync="dialogFormVisible" :before-close="handleBefore">
    <el-form :model="form">
      <el-form-item style="width: 100%" label="激活码" label-width="120px">
        <el-input style="width: 100%" v-model="form.activationCode" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleBefore">取 消</el-button>
      <el-button type="primary" @click="handleUseSure">确 定</el-button>
    </div>
  </el-dialog>

  </div>
</template>
<script>
import { getCardRollUse } from '../../../api/accept/account/account';

export default {
  props:{
    dialogFormVisible:Boolean
  },
  data(){
    return{
      form:{
        activationCode:''
      }
    }
  },
  methods:{
    handleBefore(){
      this.form.activationCode=''
      this.$emit('cancel')
    },
    async handleUseSure(){
      this.$emit('cancel')
      await getCardRollUse(this.form.activationCode)
      this.form.activationCode=''
      this.$message.success('操作成功')
      window.location.reload()
    },
  }
}
</script>
<style scoped>
/deep/ .el-dialog{
  background:#ffffff;
}
/deep/ .el-dialog__body{
}
</style>



// WEBPACK FOOTER //
// src/views/accept/purchase-membership/use-code.vue